/**
 * @description 导出默认通用配置
 */
let baseUrl;
//   process.env.NODE_ENV === "development"
//     ? "/api"
//     : "https://moodle.chenkf.cn/webservice/rest/server.php";
// let baseUrl = "https://moodle.chenkf.cn/webservice/rest/server.php";
// let baseUrl = "https://xiangyi.mtu.plus/webservice/rest/server.php";

// 导出成绩单地址
let importGradeUrl;

switch (process.env.VUE_APP_MODE) {
  case "xy-dev":
  case "xy-prod":
    baseUrl = "https://www.mtu.plus/webservice/rest/server.php";
    importGradeUrl = "https://www.mtu.plus/local/exam/export_grade_report.php";
    break;
  case "xylms-dev":
  case "xylms-prod":
    baseUrl = "http://xylms.zhftc.com/webservice/rest/server.php";
    importGradeUrl =
      "http://xylms.zhftc.com/local/exam/export_grade_report.php";
    break;
  default:
    baseUrl = "https://moodle.chenkf.cn/webservice/rest/server.php";
    importGradeUrl =
      "https://moodle.chenkf.cn/local/exam/export_grade_report.php";
    break;
}
let baseUrlArr = baseUrl.split("/");
let domainName;
if (baseUrlArr[2]) {
  domainName = baseUrlArr[0] + "//" + baseUrlArr[2];
}
console.log("domainName", domainName);

const setting = {
  idProd: process.env.NODE_ENV !== "development",
  // 接口请求时的base uri
  baseURL: baseUrl,
  // 开发以及部署时的URL
  publicPath: baseUrl,
  // 导出成绩单url
  importGradeUrl: importGradeUrl,
  // 域名
  domainName: domainName,
  // 生产环境构建文件的目录名
  outputDir: "dist",
  // 放置生成的静态资源 (js、css、img、fonts) 的 (相对于 outputDir 的) 目录。
  assetsDir: "static",
  title: "考试管理系统",
  //是否显示页面底部自定义版权信息
  footerCopyright: true,
  //是否显示顶部进度条
  progressBar: true,
  //缓存路由的最大数量
  keepAliveMaxNum: 99,
  // 路由模式，可选值为 history 或 hash
  routerMode: "hash",
  //不经过token校验的路由
  routesWhiteList: [],
  //加载时显示文字
  loadingText: "正在加载中...",
  //token名称
  tokenName: "XX-Token",
  //设备名称
  deviceName: "XX-Device-Type",
  //token在localStorage、sessionStorage存储的key的名称
  tokenTableName: "exam",
  //token存储位置localStorage sessionStorage
  storage: "localStorage",
  //token失效回退到登录页时是否记录本次的路由
  recordRoute: false,
  //是否显示logo，不显示时设置false，显示时请填写logo图标名称
  logo: "",
  //是否显示在页面高亮错误
  errorLog: ["development"],
  //是否开启登录拦截
  loginInterception: true,
  //是否开启登录RSA加密
  loginRSA: false,
  //intelligence和all两种方式，前者后端权限只控制permissions不控制view文件的import（前后端配合，减轻后端工作量），all方式完全交给后端前端只负责加载
  authentication: "intelligence",
  //vertical布局时是否只保持一个子菜单的展开
  uniqueOpened: true,
  //vertical布局时默认展开的菜单path，使用逗号隔开建议只展开一个
  defaultOopeneds: [""],
  //需要加loading层的请求，防止重复提交
  debounce: ["doEdit"],
  //需要自动注入并加载的模块
  providePlugin: {},
  //npm run build时是否自动生成7z压缩包
  build7z: false,
  //是否显示终端donation打印
  donation: true,
};
module.exports = setting;
